module.exports = {"440811100":"麻章镇","440811101":"太平镇","440811102":"湖光镇","440811170":"东山镇","440811171":"东简镇","440811172":"民安镇","440811173":"硇洲镇","440811450":"湖光农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440811.json
// module id = 1826
// module chunks = 0